import { useRecoilState } from "recoil"

import layoutStates from "src/recoil/atoms/layout"
import { useCurrentAvatarInfo } from "src/conditionals/Avatar"
import { useWatchPartyController } from "src/hooks/useWatchParty"

export const useVideoPopup = () => {
  const { avatarId } = useCurrentAvatarInfo()
  const { stopWatchParty } = useWatchPartyController()
  const [isVideoPopupActive, setVideoPopupActive] = useRecoilState(
    layoutStates.isFloatingDivActive
  )

  // Currently if avatar is present we popup only Avatar and show shared video on MVW
  const showAvatarPopupAndWPOnMVW = avatarId

  const isAvatarPopupActive = showAvatarPopupAndWPOnMVW && isVideoPopupActive

  const toggleVideoPopup = (visible: boolean) => {
    if (visible) {
      // Set width to 0px to hide container for smooth transition
      const popupContainer = document.getElementById("main-mvw-container")
      popupContainer.style.width = "0px"
    } else {
      // Stop WP when popup is closed
      if (showAvatarPopupAndWPOnMVW) {
        stopWatchParty()
      }
    }

    setVideoPopupActive(visible)
  }

  return {
    isVideoPopupActive,
    isAvatarPopupActive,
    showAvatarPopupAndWPOnMVW,
    toggleVideoPopup
  }
}
